import { SelectedSideOrdersT } from '@features/orderForm/stepSelectSideOrders/services/redux/stepSelectSideOrders.slice';

export const amountOfSelectedSideOrders = (
  selectedSideOrders: SelectedSideOrdersT,
  activeDay: string
) =>
  Object.values(selectedSideOrders[activeDay] || {}).reduce(
    (sum, value) => sum + (value?.multiplier || 0),
    0
  );

export const amountOfSelectedSideOrdersLimitedByMaximumSelectedMeals = (
  selectedSideOrders: SelectedSideOrdersT,
  activeDay: string
) =>
  prepareAmountOfSelectedSideOrdersLimitedByMaximumSelectedMeals(
    selectedSideOrders[activeDay] || {}
  );

export const prepareAmountOfSelectedSideOrdersLimitedByMaximumSelectedMeals = (
  selectedSideOrdersForActiveDay: SelectedSideOrdersT[keyof SelectedSideOrdersT]
) =>
  Object.values(selectedSideOrdersForActiveDay || {}).reduce(
    (sum, value) =>
      sum + (value?.limitedByMaximumSelectedMeals ? value?.multiplier || 0 : 0),
    0
  );
